export default __webpack_public_path__ + "static/media/onboarding_icon.2488fab1.svg";